const template = `
    <section class="container page-404 custom-fonts"  id="hidden-title">
        <article>
            <h2 class="big-title white">404</h2>
            <h3 class="white">Esta página se encuentra perdida en el desierto</h3>
            <p>LO SENTIMOS, NO HEMOS PODIDO ENCONTRAR LA PÁGINA QUE BUSCAS. VE A LA PÁGINA DE INICIO O CONTACTA CON NOSOTROS.</p>
            <a href="/"  class="btn">Volver al inicio</a>
        </article>
    </section>
    <!--Bg component-->
    <section class="bg">
        <article>
            <img src="/themes/sabios_theme/sources/dist/assets/img/jpg/bg-steps.jpg" alt="">
        </article>
    </section>
    <!--End component-->
`;


const Page404 = ()=>{
    const block = document.querySelector('#block-sabios-theme-content');

    if(block.textContent.trim() == "The requested page could not be found."){
        document.querySelector('main').innerHTML = template;
    }
}

export { Page404 };


